import { FC } from 'react';
import AppRoutes from './routes/index'
import './App.css';

const App: FC = () => <AppRoutes />

export default App;
